module.exports = __webpack_public_path__ + "img/hu_yes.c4e9383e.png";